//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'comment-item',
  components: {},
  props: ['data', 'index'],
  mounted() {
  },
  methods: {
    handleToLike(e,materialCommentId) {
      this.$emit('handleToLike',e,materialCommentId);
    },
    handleToReply() {
      this.$emit('handleToReply');
    },
    handleToLookMore() {
      this.$emit('handleToLookMore');
    }
  },
  data() {
    return {};
  }
};



// WEBPACK FOOTER //
// ./src/components/app/commentItem.vue